export default {
  code: 'V7.0.0',
  time: '2026-07-17',
};
